module.exports = __webpack_public_path__ + "img/audio.b3059e99.svg";